import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBusinessRelationsIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 18 20",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.87502 19H3.25C2.00735 19 0.999992 17.9926 1 16.75L1.00009 3.24999C1.00009 2.00736 2.00745 1 3.25009 1H13.3754C14.618 1 15.6254 2.00736 15.6254 3.25001V7.75002M4.93786 5.50001H11.6879M4.93786 8.87502H11.6879M11.6879 13.3319V16.0922C11.6879 17.4563 13.1423 18.7073 14.5064 18.7073C15.8704 18.7073 17.3129 17.4563 17.3129 16.0922V12.6055C17.3129 11.8833 16.8978 11.1505 15.9743 11.1505C14.9864 11.1505 14.5064 11.8833 14.5064 12.6055V15.947M4.93786 12.25H8.31287",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		className: "stroke"
	})
});
export default SvgBusinessRelationsIcon;
